// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/ellipsis-vertical.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'ellipsis-vertical',
  version: 'outline',
  paths: [
    {
      d: 'M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z',
    },
  ],
}
